/*
	FontMetrics.js
*/


var b = require('./base.js');
var Class = require('./class.js');
var DOM = require('./dom.js');

var FontMetrics = module.exports = Class(null, {
	__init__: function(metricstyle) {
		this.container = DOM.DIV();
		this.measured = {};
		for(var i = 32; i < 255; i++){
			this.measured[i] = {};
			this.measured[i].span = DOM.style(metricstyle, DOM.SPAN(null, String.fromCharCode(i)));
			DOM.addNodes(this.container, this.measured[i].span);
		}

		DOM.addNodes(document.body, this.container);
		for(var i in this.measured){
			this.measured[i].len = DOM.getWidth(this.measured[i].span);
		}

		var spacingStr = 'a&nbsp;a';
		var secondStr = 'a a'
		this.spacingSpan = DOM.style(metricstyle, DOM.SPAN(null, ''));
		this.spacingSpan.innerHTML = spacingStr;
		DOM.addNodes(this.container, this.spacingSpan);
		var nbspLen = DOM.getWidth(this.spacingSpan) - (this.measured[spacingStr.charCodeAt(0)].len * 2);
		this.spacingSpan.innerHTML = secondStr;
		var spaceLen = DOM.getWidth(this.spacingSpan) - (this.measured[secondStr.charCodeAt(0)].len * 2);
		this.measured[32].len = Math.min(nbspLen, spaceLen);
		DOM.removeNodes(document.body, this.container);
	},

	calcMetrics: function(str){
		str == undefined ? str = '' : str = str;
		len = 0;
		for(i = 0; i < str.length; i++){
			len += this.measured[str.charCodeAt(i)].len;
		}
		return len;
	}
})
